const _getHours = (date) => {
  if (!date || !date.getHours) {
    return null;
  }

  return date.getHours();
};

export const isAM = (date) => {
  const hours = _getHours(date);

  return hours !== null && hours < 12;
};

export const isPM = (date) => {
  const hours = _getHours(date);

  return hours !== null && hours >= 12;
};
